// import React, { useEffect, useState } from "react";
// import { useMutation } from "react-query";

// import { toast } from "react-toastify";
// import { patchDyanmicUiFn, postDyanmicUiFn } from "../../../Services/DynamicPageUi";
// import { useLocation, useNavigate, useParams } from "react-router-dom";

// export default function AddDynamicUI() {
//     const [pageName, setPageName] = useState("");
//     const [data, setData] = useState({ pagetypename: {} });
//     const [order, setOrder] = useState([]);
//     const [selection, setSelection] = useState("");

//     const navigate = useNavigate()

//     const { type } = useParams()

//     const { state } = useLocation()

//     useEffect(() => {
//         if (state) {

//             setSelection(state?.page_type_name === "default" ? "default" : "other")

//             setPageName(state?.page_type_name || "");

//             if (Array.isArray(state?.page_format)) {

//                 const formatObj = {};
//                 const formatOrder = [];
//                 state.page_format.forEach((item) => {
//                     formatObj[item.key] = item.value;
//                     formatOrder.push(item.key);
//                 });
//                 setData({ pagetypename: formatObj });
//                 setOrder(formatOrder);
//             }
//         }
//     }, [state]);

//     const { mutate: addPage } = useMutation(postDyanmicUiFn, {
//         onSuccess: (res) => {
//             if (res?.data?.response_code === 200) {

//                 toast.success(res?.data?.message)
//                 setPageName("")
//                 setData({ pagetypename: {} })
//                 setOrder([])
//                 navigate(-1)
//             }
//             else {

//                 toast.warn(res?.data?.message)
//             }

//         }
//     });

//     const { mutate: UpadatePage } = useMutation(patchDyanmicUiFn, {
//         onSuccess: (res) => {
//             if (res?.data?.response_code === 200) {

//                 toast.success(res?.data?.message)
//                 setPageName("")
//                 setData({ pagetypename: {} })
//                 setOrder([])
//                 navigate(-1)
//             }
//             else {

//                 toast.warn(res?.data?.message)
//             }

//         }
//     });

//     const addSection = (type) => {
//         setData((prev) => {
//             const existingKeys = Object.keys(prev.pagetypename).filter((k) =>
//                 k.startsWith(type)
//             );

//             const newIndex = existingKeys.length === 0 ? "" : existingKeys.length;
//             const newKey = type + newIndex;

//             if (prev.pagetypename[newKey]) return prev;

//             setOrder((prevOrder) => [...prevOrder, newKey]);

//             return {
//                 ...prev,
//                 pagetypename: {
//                     ...prev.pagetypename,
//                     [newKey]: ""
//                 }
//             };
//         });
//     };

//     const handleChange = (key, value) => {
//         setData((prev) => ({
//             ...prev,
//             pagetypename: {
//                 ...prev.pagetypename,
//                 [key]: value
//             }
//         }));
//     };

//     const handleRemove = (key) => {
//         setData((prev) => {
//             const updated = { ...prev.pagetypename };
//             delete updated[key];

//             const newOrder = order.filter((k) => k !== key);
//             setOrder(newOrder);

//             return { pagetypename: updated };
//         });
//     };

//     const handleSubmit = () => {
//         const orderedData = {};
//         order.forEach((key) => {
//             if (data.pagetypename[key] !== "") {
//                 orderedData[key] = data.pagetypename[key];
//             }
//         });

//         const arrayData = order.map((key) => ({
//             key: key,
//             value: data.pagetypename[key]
//         }));

//         const finalData = {
//             page_type_name: pageName,
//             page_format: arrayData,
//             store: localStorage.getItem("store_id")
//         };

//         if (type === "add") {
//             addPage(finalData);

//         }

//         else {
//             UpadatePage({ page_format_id: state?.id, ...finalData })

//         }

//     };

//     const handleSelectionChange = (e) => {
//         const value = e.target.value;
//         setSelection(value);
//         if (value === "default") {
//             setPageName("default");
//         } else {
//             setPageName("");
//         }
//     };

//     return (
//         <div className="p-6 m-5 max-w-xl mx-auto bg-white text-black rounded-2xl shadow-lg space-y-6">
//             {/* Title */}
//             <h2 className="text-2xl font-semibold capitalize border-b pb-2">{type} Dynamic Page UI</h2>

//             {/* Page Name Selector */}
//             <div className="space-y-2">
//                 <label className="block font-medium text-gray-700">Select Page Name Type</label>
//                 <div className="flex gap-4">
//                     <select
//                         value={selection}
//                         onChange={handleSelectionChange}
//                         className="border border-gray-300 px-3 py-2 rounded-lg flex-1 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
//                     >
//                         <option disabled value="">Select Page Type</option>
//                         <option value="default">Default</option>
//                         <option value="other">Other</option>
//                     </select>
//                 </div>
//             </div>

//             {/* Page Name Input */}
//             <div className="space-y-2">
//                 <label className="block font-medium text-gray-700">Page Name</label>
//                 <input
//                     type="text"
//                     value={pageName}
//                     onChange={(e) => setPageName(e.target.value)}
//                     placeholder="Enter page name"
//                     className="border border-gray-300 px-3 py-2 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition disabled:bg-gray-100"
//                     disabled={selection === "default"}
//                 />
//             </div>

//             {/* Section Selector and Submit */}
//             <div className="flex gap-4 items-end">
//                 <div className="flex-1">
//                     <label className="block font-medium text-gray-700 mb-1">Add Section</label>
//                     <select
//                         onChange={(e) => {
//                             if (e.target.value) {
//                                 addSection(e.target.value);
//                                 e.target.value = "";
//                             }
//                         }}
//                         defaultValue=""
//                         className="border border-gray-300 px-3 py-2 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
//                     >
//                         <option value="">Select Section</option>
//                         <option value="banner">Banner</option>
//                         <option value="product">Product</option>
//                         <option value="product_varient">Product Variant</option>
//                     </select>
//                 </div>
//                 <button
//                     onClick={handleSubmit}
//                     className="h-10 px-6 bg-green-600 hover:bg-green-700 transition text-white rounded-lg shadow-md"
//                 >
//                     Submit
//                 </button>
//             </div>

//             {/* Dynamic Section Inputs */}
//             <div className="space-y-4">
//                 {order.map((key) => (
//                     <div
//                         key={key}
//                         className="flex items-center gap-4 p-4 border border-gray-300 rounded-lg bg-gray-50"
//                     >
//                         <label className="font-medium w-32 capitalize text-gray-700">{key}</label>
//                         <input
//                             type="number"
//                             value={data.pagetypename[key]}
//                             onChange={(e) => handleChange(key, e.target.value)}
//                             placeholder={`Enter ${key} number`}
//                             className="border border-gray-300 px-3 py-2 rounded-lg w-44 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
//                         />
//                         <button
//                             onClick={() => handleRemove(key)}
//                             className="text-red-600 hover:text-red-800 text-lg"
//                             title="Remove Section"
//                         >
//                             ❌
//                         </button>
//                     </div>
//                 ))}
//             </div>

//             {/* Uncomment to show JSON Preview */}
//             {/*
//     <div className="mt-6 bg-gray-100 p-4 rounded-lg text-sm font-mono">
//         <h3 className="font-bold mb-2">Preview:</h3>
//         <pre>
//             {JSON.stringify(
//                 {
//                     pagename: pageName,
//                     pagetypename: order.reduce((acc, k) => {
//                         acc[k] = data.pagetypename[k];
//                         return acc;
//                     }, {})
//                 },
//                 null,
//                 2
//             )}
//         </pre>
//     </div>
//     */}
//         </div>

//     );
// }

import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import {
  patchDyanmicUiFn,
  postDyanmicUiFn,
} from "../../../Services/DynamicPageUi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FormControl, MenuItem, Select } from "@mui/material";
import axiosInstance, { baseUrl } from "../../../config/axios";
// import axios from "axios";

export default function AddDynamicUI() {
  const [pageName, setPageName] = useState("");
  const [data, setData] = useState({ pagetypename: {} });
  const [order, setOrder] = useState([]);
  const [selection, setSelection] = useState("");

  const [categorydata, setCategoryData] = useState([]);

  // ✅ new states for multiple additions
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [brands, setBrands] = useState([]);

  const navigate = useNavigate();
  const { type } = useParams();
  const { state } = useLocation();

  useEffect(() => {
    if (state) {
      setSelection(state?.page_type_name === "default" ? "default" : "other");
      setPageName(state?.page_type_name || "");

      if (Array.isArray(state?.page_format)) {
        const formatObj = {};
        const formatOrder = [];
        state.page_format.forEach((item) => {
          formatObj[item.key] = item.value;
          formatOrder.push(item.key);
        });
        setData({ pagetypename: formatObj });
        setOrder(formatOrder);
      }

      if (state?.category)
        setCategories(
          state.category?.map((i) => ({
            title: i?.title,
            id: i?.category_id,
          })) || [],
        );
      if (state?.sub_category)
        setSubCategories(
          state.sub_category?.map((i) => ({
            title: i?.title,
            id: i?.sub_category_id,
          })) || [],
        );
      if (state?.brand)
        setBrands(
          state.brand?.map((i) => ({
            title: i?.title,
            id: i?.brand_id,
          })) || [],
        );
    }
  }, [state]);

  const { mutate: addPage } = useMutation(postDyanmicUiFn, {
    onSuccess: (res) => {
      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.message);
        resetForm();
        navigate(-1);
      } else toast.warn(res?.data?.message);
    },
  });

  const { mutate: updatePage } = useMutation(patchDyanmicUiFn, {
    onSuccess: (res) => {
      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.message);
        resetForm();
        navigate(-1);
      } else toast.warn(res?.data?.message);
    },
  });

  const resetForm = () => {
    setPageName("");
    setData({ pagetypename: {} });
    setOrder([]);
    setCategories([]);
    setSubCategories([]);
    setBrands([]);
  };

  // --------------------------
  //  DYNAMIC UI SECTION LOGIC
  // --------------------------
  const addSection = (type) => {
    setData((prev) => {
      const existingKeys = Object.keys(prev.pagetypename).filter((k) =>
        k.startsWith(type),
      );
      const newIndex = existingKeys.length === 0 ? "" : existingKeys.length;
      const newKey = type + newIndex;
      if (prev.pagetypename[newKey]) return prev;

      setOrder((prevOrder) => [...prevOrder, newKey]);

      return {
        ...prev,
        pagetypename: {
          ...prev.pagetypename,
          [newKey]: "",
        },
      };
    });
  };

  const handleChange = (key, value) => {
    setData((prev) => ({
      ...prev,
      pagetypename: {
        ...prev.pagetypename,
        [key]: value,
      },
    }));
  };

  const handleRemove = (key) => {
    setData((prev) => {
      const updated = { ...prev.pagetypename };
      delete updated[key];
      const newOrder = order.filter((k) => k !== key);
      setOrder(newOrder);
      return { pagetypename: updated };
    });
  };

  // --------------------------
  //  CATEGORY / SUBCATEGORY / BRAND MULTI ADD
  // --------------------------
  const handleAddItem = (listSetter, list, newItem) => {
    if (newItem.title && newItem.id) {
      listSetter([...list, newItem]);
    }
  };

  const handleRemoveItem = (listSetter, list, index) => {
    const updated = list.filter((_, i) => i !== index);
    listSetter(updated);
  };

  // --------------------------
  //  FINAL SUBMIT
  // --------------------------
  const handleSubmit = () => {
    const orderedData = {};
    order.forEach((key) => {
      if (data.pagetypename[key] !== "") {
        orderedData[key] = data.pagetypename[key];
      }
    });

    const arrayData = order.map((key) => ({
      key: key,
      value: data.pagetypename[key],
    }));

    const finalData = {
      page_type_name: pageName,
      page_format: arrayData,
      store: localStorage.getItem("store_id"),
      category: categories.map((c) => ({
        title: c.title,
        category_id: c.id,
      })),
      sub_category: subCategories.map((c) => ({
        title: c.title,
        sub_category_id: c.id,
      })),
      brand: brands.map((b) => ({
        title: b.title,
        brand_id: b.id,
      })),
    };

    if (type === "add") addPage(finalData);
    else updatePage({ page_format_id: state?.id, ...finalData });
  };

  const handleSelectionChange = (e) => {
    const value = e.target.value;
    setSelection(value);
    if (value === "default") setPageName("default");
    else setPageName("");
  };

  const mainCategoryList = () => {
    axiosInstance
      .get(
        `api/category-subcategory-brand-list-api/`,
        {
          store_id: localStorage.getItem("store_id"),
        },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        setCategoryData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    mainCategoryList();
  }, []);

  return (
    <div className="p-6 m-5 max-w-3xl mx-auto bg-white text-black rounded-2xl shadow-lg space-y-6  max-h-[90vh] overflow-y-auto">
      <h2 className="text-2xl font-semibold capitalize border-b pb-2">
        {type} Dynamic Page UI
      </h2>

      {/* Page Name Type */}
      <div className="space-y-2">
        <label className="block font-medium text-gray-700">
          Select Page Name Type
        </label>
        <select
          value={selection}
          onChange={handleSelectionChange}
          className="border border-gray-300 px-3 py-2 rounded-lg w-full focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Select Page Type</option>
          <option value="default">Default</option>
          <option value="other">Other</option>
        </select>
      </div>

      {/* Page Name */}
      <div className="space-y-2">
        <label className="block font-medium text-gray-700">Page Name</label>
        <input
          type="text"
          value={pageName}
          onChange={(e) => setPageName(e.target.value)}
          placeholder="Enter page name"
          className="border border-gray-300 px-3 py-2 rounded-lg w-full focus:ring-2 focus:ring-blue-500"
          disabled={selection === "default"}
        />
      </div>

      {/* Add Section */}
      <div className="flex gap-4 items-end">
        <div className="flex-1">
          <label className="block font-medium text-gray-700 mb-1">
            Add Section
          </label>
          <select
            onChange={(e) => {
              if (e.target.value) {
                addSection(e.target.value);
                e.target.value = "";
              }
            }}
            defaultValue=""
            className="border border-gray-300 px-3 py-2 rounded-lg w-full focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select Section</option>
            <option value="banner">Banner</option>
            <option value="product">Product</option>
            <option value="product_varient">Product Variant</option>
          </select>
        </div>
        {/* <button
                    onClick={handleSubmit}
                    className="h-10 px-6 bg-green-600 hover:bg-green-700 text-white rounded-lg shadow-md"
                >
                    Submit
                </button> */}
      </div>

      {/* Dynamic Sections */}
      <div className="space-y-4">
        {order.map((key) => (
          <div
            key={key}
            className="flex items-center gap-4 p-1 border rounded-lg bg-gray-50"
          >
            <label className="font-medium w-32 capitalize text-gray-700">
              {key}
            </label>
            <input
              type="number"
              value={data.pagetypename[key]}
              onChange={(e) => handleChange(key, e.target.value)}
              placeholder={`Enter ${key} number`}
              className="border border-gray-300 px-3 py-2 rounded-lg w-44 focus:ring-2 focus:ring-blue-500"
            />
            <button
              onClick={() => handleRemove(key)}
              className="text-red-600 hover:text-red-800 text-lg"
            >
              ❌
            </button>
          </div>
        ))}
      </div>

      {/* Category / Subcategory / Brand Sections */}
      {[
        {
          title: "Category",
          list: categories,
          setList: setCategories,
          data:
            categorydata?.category?.map((i) => ({
              title: i?.category,
              id: i?.id,
            })) || [],
        },
        {
          title: "Sub Category",
          list: subCategories,
          setList: setSubCategories,
          data:
            categorydata?.subcategory?.map((i) => ({
              title: i?.subcategory,
              id: i?.id,
            })) || [],
        },
        {
          title: "Brand",
          list: brands,
          setList: setBrands,
          data:
            categorydata?.brand?.map((i) => ({
              title: i?.brand_name,
              id: i?.id,
            })) || [],
        },
      ].map((section) => (
        <div key={section.title} className="border-t pt-4">
          <h3 className="text-lg font-semibold mb-3">{section.title}s</h3>
          <AddMultiList
            section={section}
            handleAddItem={handleAddItem}
            handleRemoveItem={handleRemoveItem}
          />
        </div>
      ))}

      <div className=" flex items-center justify-center">
        <button
          onClick={handleSubmit}
          className="h-10 px-6 bg-green-600 hover:bg-green-700 text-white rounded-lg shadow-md"
        >
          Submit
        </button>
      </div>
    </div>
  );
}

// ✅ Reusable Subcomponent for Category / Subcategory / Brand Multi Add
function AddMultiList({ section, handleAddItem, handleRemoveItem }) {
  const [newItem, setNewItem] = useState({ title: "", id: "" });

  return (
    <div className="space-y-3">
      <div className="flex gap-3 justify-between">
        <input
          type="text"
          placeholder={`${section.title} Title`}
          value={newItem.title}
          onChange={(e) => setNewItem({ ...newItem, title: e.target.value })}
          className="border border-gray-300 px-3 py-2 rounded-lg flex-1"
        />
        {/* <input
                    type="number"
                    placeholder={`${section.title} ID`}
                    value={newItem.id}
                    onChange={(e) => setNewItem({ ...newItem, id: e.target.value })}
                    className="border border-gray-300 px-3 py-2 rounded-lg "
                /> */}

        <FormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            size="small"
            name="sub_category_id"
            className="mt-1"
            value={newItem.id}
            placeholder="Select"
            onChange={(e) => setNewItem({ ...newItem, id: e.target.value })}
          >
            <MenuItem disabled value={""}>
              Select
            </MenuItem>
            {section?.data?.map((elem) => (
              <MenuItem value={elem?.id}>{elem?.title}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <button
          onClick={() => {
            handleAddItem(section.setList, section.list, newItem);
            setNewItem({ title: "", id: "" });
          }}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 rounded-lg"
        >
          Add
        </button>
      </div>

      <ul className="space-y-2">
        {section.list.map((item, i) => (
          <li
            key={i}
            className="flex justify-between items-center bg-gray-100 px-3 py-2 rounded-lg"
          >
            <span>
              <strong>Heading: </strong>
              {item.title} ({" "}
              {section.data.find((elem) => elem.id === item.id)?.title})
            </span>

            <button
              onClick={() => handleRemoveItem(section.setList, section.list, i)}
              className="text-red-600 hover:text-red-800"
            >
              ❌
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
